export default __webpack_public_path__ + "static/media/AMD_Logo 1.36eeda61.svg";